import { EmailContact } from "@/Common/Api/Contacts/Dto/EmailContact";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { LinkedContact } from "@/Common/Api/Patient/Dto/LinkedContact";
import { ProfileTab } from "@/Common/Models/Patient/PatientEnums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { RelationView } from "@/Patient/Components/Profile/Relations/RelationView";
import { PatientModifyEmailPopup } from "../PatientModifyEmailPopup";
import { AddressesView } from "./ContactComponents/AddressesView";
import { EmailsView } from "./ContactComponents/EmailsView";
import { PhonesView } from "./ContactComponents/PhonesView";
import { IPatientProfileContactsProps } from "./ContactsEdit";

import styles from "./ContactsView.module.scss";

class ContactsView extends React.Component<IPatientProfileContactsProps, any> {
    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const model = this.props.model;

        const sortedAddress = model.get("Addresses").toArray().sortByPropertyDesc(p => p.IsPreferred);
        const sortedPhones: PhoneNumber[] = model.get("PhoneNumbers").toArray().sortByPropertyDesc(p => p.IsPreferred);

        const emails = model.get("Emails");
        const emailContacts = emails
            .map(email => {
                let contactPoint = model.get("ContactPoints").find(e => e.Id === email.ContactPoint_id);
                return EmailContact.toEmailContact(email, contactPoint);
            })
            .toArray();

        return (
            <div className="patient-prof">
                {model.get("ShowChangeEmailPopup") &&
                    <PatientModifyEmailPopup emailContacts={emailContacts} doNotEmail={model.get("DoNotEmail")} />
                }
                <div className="scrollable" data-cy="patientProfile-contacts-view">
                    <div className="block separated">
                        <div className={`${styles.sectionHeader} heading`}>
                            <h3 className="thin-font">{cacheStore.GetString("PatientLabel")}</h3>
                        </div>

                        <div className={`${styles.patientContactSection} patient-profile fxd-wdth-container edit`}>
                            <div className="tb">
                                <div className="tbc left">
                                    <AddressesView addresses={sortedAddress} />
                                </div>
                                <div className="tbc right">
                                    <PhonesView phones={sortedPhones} />
                                    <EmailsView
                                        doNotEmail={model.get("DoNotEmail")}
                                        emails={emails.toArray()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Patient Representative Section */}
                    {this.renderListedRelationContacts(false)}
                    {/* Emergency Contact Section */}
                    {this.renderListedRelationContacts(true)}
                </div>
            </div>
        );
    }

    private renderListedRelationContacts(isEmergencyContactSection: boolean): JSX.Element {
        const contacts: LinkedContact[] = isEmergencyContactSection
            ? this.props.model.get("EmergencyContacts").toArray()
            : this.props.model.get("Representatives").toArray();

        const sectionTitle: string = isEmergencyContactSection
            ? cacheStore.GetString("EmergencyContactLabel")
            : cacheStore.GetString("PatientRepresentativeContactLabel");

        return (
            <div className="block separated">
                <div className={`${styles.sectionHeader} heading`}>
                    <h3 className="thin-font">{sectionTitle}</h3>
                    <div className={styles.addButton}>
                        <a
                            onClick={() => sessionStore.dispatch(LocalPatientOperations.Profile.ChangeProfileTabs, { value: ProfileTab.Relationships })}
                        >
                            <span>{`[+] ${cacheStore.GetString("AddLabel")}`}</span>
                        </a>
                    </div>
                </div>
                <div className={styles.bodyList}>
                    <div className={styles.list}>
                        {contacts.map(contact => (
                            <RelationView
                                key={contact.Id}
                                linkedContact={contact}
                                hidePermissions
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export { ContactsView };
